/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_Jane_DoeInputs */

const en_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Jane Doe`)
};

const es_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. María Pérez`)
};

const fr_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Jane Doe`)
};

const de_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Max Mustermann`)
};

const ja_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: 山田 花子`)
};

const zh_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：张三`)
};

const ar_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: فلان الفلاني`)
};

const id_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Jane Doe`)
};

const it_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Mario Rossi`)
};

const ru_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, Иван Иванов`)
};

const pt_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Maria Silva`)
};

const ko_eg_jane_doe = /** @type {(inputs: Eg_Jane_DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: 홍길동`)
};

/**
* | output |
* | --- |
* | "e.g. Jane Doe" |
*
* @param {Eg_Jane_DoeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_jane_doe = /** @type {((inputs?: Eg_Jane_DoeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_Jane_DoeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_jane_doe(inputs)
	if (locale === "es") return es_eg_jane_doe(inputs)
	if (locale === "fr") return fr_eg_jane_doe(inputs)
	if (locale === "de") return de_eg_jane_doe(inputs)
	if (locale === "ja") return ja_eg_jane_doe(inputs)
	if (locale === "zh") return zh_eg_jane_doe(inputs)
	if (locale === "ar") return ar_eg_jane_doe(inputs)
	if (locale === "id") return id_eg_jane_doe(inputs)
	if (locale === "it") return it_eg_jane_doe(inputs)
	if (locale === "ru") return ru_eg_jane_doe(inputs)
	if (locale === "pt") return pt_eg_jane_doe(inputs)
	return ko_eg_jane_doe(inputs)
});